var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.containerClass},[_c('incomplete-students'),_c('recent-student-submissions'),_c('incomplete-staff'),_c('recent-staff-submissions')],1)}
var staticRenderFns = []

export { render, staticRenderFns }